import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';

import Select from 'components/ui/SelectField';
import { FIXED_ADDENDUM } from '../../CreateDocumentTemplateDialog';

import { getTranslatedString } from 'helpers/i18n';

const StyledLabel = styled.label`
  margin-top: 10px;
`;

const StyledSelect = styled(Select)`
  width: 100%;
`;

const StyledError = styled.div`
  color: red;
  margin-top: 5px;
`;

const BaseDocumentTemplateSelector = ({
  values,
  errors,
  touched,
  setFieldValue,
  documentTemplates,
}) => {
  if (values.signable_doc_type !== FIXED_ADDENDUM) {
    return null;
  }

  let documentTemplatesOptions = [];
  if (!isEmpty(documentTemplates)) {
    // Fiter for lease type document templates where those document templates
    // are for the properties currently selected

    documentTemplatesOptions = documentTemplates
      .filter(
        (documentTemplate) =>
          documentTemplate.signable_doc_type === 'lease' &&
          values.property_uuids.some((property_uuid) =>
            documentTemplate.property_uuids.includes(property_uuid)
          )
      )
      .map((documentTemplate) => ({
        label: documentTemplate.title,
        value: documentTemplate.id,
      }));
  }

  return (
    <React.Fragment>
      <StyledLabel>
        {getTranslatedString(
          'landlordPortal.documentTemplate.fieldType.selectDocumentTemplatesToAttach'
        )}
      </StyledLabel>
      <StyledSelect
        mode="multiple"
        name="base_document_template_ids"
        showSearch
        placeholder={getTranslatedString(
          'landlordPortal.documentTemplate.fieldType.selectBaseDocumentTemplates'
        )}
        size="large"
        value={values.base_document_template_ids}
        onChange={(documentTemplateIds) => {
          setFieldValue('base_document_template_ids', documentTemplateIds);
        }}
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {documentTemplatesOptions.map((documentTemplate) => (
          <Select.Option
            value={documentTemplate.value}
            key={`document-template-id-${documentTemplate.value}`}
          >
            {documentTemplate.label}
          </Select.Option>
        ))}
      </StyledSelect>
      {errors.base_document_template_ids && touched.base_document_template_ids ? (
        <StyledError>{errors.base_document_template_ids}</StyledError>
      ) : null}
    </React.Fragment>
  );
};

const mapStoreToProps = (store) => ({
  documentTemplates: store.landlordDocumentTemplates.documentTemplates,
});

const mapDispatchToProps = {};

export default connect(mapStoreToProps, mapDispatchToProps)(BaseDocumentTemplateSelector);
